<app-login-content-container>
  <div class="d-flex flex-column h-100">
    <div class="mfa-container">
      <div class="mfa-title">
        <h1>{{ "mfa.mfa_title" | translate }}</h1>
  
        <div class="mfa-subheading">{{ "mfa.enter_code_msg" | translate }}</div>
      </div>
  
      <div class="p-none p-md-5">      
  
        <code-input mfaarialabel
          #codeInput
          class="mt-3 passscode-boxes"
          [isCodeHidden]="false"
          [codeLength]="6"
          (codeCompleted)="onCodeCompleted($event)"
          (keydown.enter)="verifyMfaCode()"
        >
        </code-input>
  
        <div class="resend-btn__container">
          <button title="Resend code" mat-button (click)="resendMfaCode()">
            {{ "button.resend_code" | translate }}
          </button>
        </div>
  
        <div class="d-none d-md-flex mt-3" style="justify-content: center">
          <uw-button
            customStyle="margin-right: 1em;"
            [isMediumSize]="true"
            (buttonClick)="verifyMfaCode()"
            btnLabel="{{ 'button.verify_code' | translate }}"
          ></uw-button>
  
          <!-- <uw-button
        customStyle="margin-right: 1em;"
        [isMediumSize]="true"
        (buttonClick)="resendMfaCode()"
        btnLabel="{{ 'button.resend_code' | translate }}"
      ></uw-button>
  
      <uw-button
        [isMediumSize]="true"
        (buttonClick)="returnToSignIn()"
        btnLabel="{{ 'auth.return_to_sign_in' | translate }}"
      ></uw-button> -->
        </div>
  
        <!-- mobile view -->
        <div class="d-flex flex-column d-md-none mt-3 align-items-center">
          <uw-button
            customStyle="margin-bottom: 1em;"
            [isMediumSize]="true"
            (buttonClick)="verifyMfaCode()"
            btnLabel="{{ 'button.verify_code' | translate }}"
          ></uw-button>
  
          <!-- <uw-button
        customStyle="width:100%!important; margin-bottom: 1em;"
        [isMediumSize]="true"
        (buttonClick)="resendMfaCode()"
        btnLabel="{{ 'button.resend_code' | translate }}"
      ></uw-button>
  
       <uw-button
        customStyle="width:100%!important;"
        [isMediumSize]="true"
        (buttonClick)="returnToSignIn()"
        btnLabel="{{ 'auth.return_to_sign_in' | translate }}"
      ></uw-button> -->
        </div>
      </div>    
    </div>
  
    <uw-language-selector></uw-language-selector>
  </div> 
</app-login-content-container>
